import React from 'react';
import { SelectValueViewer } from 'components';
import { EntityValueViewerProps } from './EntityValueViewer.props';
import { useCashFlowContext } from '../context/CashFlowContext';

const EntityValueViewer = (props: EntityValueViewerProps) => {
  const { entityOptions } = useCashFlowContext();

  return <SelectValueViewer {...props} options={entityOptions} />;
};

export default EntityValueViewer;
